import React from "react";

function ConfirmCloseModal(props) {
  //We have two separate click handlers, one for the yes and one for the no button
  //On yes click, we set showConfirmCloseModal to false to close the confirmation message modal and the call the
  // props.closeRootModal method which closes the parent modal On no click, we set showConfirmCloseModal to false to
  // close the confirmation message modal, but set the confirmCloseModalIsOpen variable to false to know it has closed.
  // we do not call props.closeRootModal so the parent modal stays open
  function yesClickHandler() {
    props.setShowConfirmCloseModal(false);
    props.setConfirmCloseModalIsOpen(false);
    props.closeRootModal();
  }

  function noClickHandler() {
    props.setShowConfirmCloseModal(false);
    props.setConfirmCloseModalIsOpen(false);
    // reset focus to the parent modal
    props.setResetFocus(true);
  }

  return (
    <div className="ugc-contribution-modal--confirm-close-container">
      <h2 className="h3 ugc-contribution-modal--confirm-close-container-title">
        Discard comments?
      </h2>
      <p>The comments you have made so far won't be saved</p>
      <div>
        <div className="modal__buttons-wrapper ugc-contribution-modal--confirm-close-cancel">
          <button
            className="govuk-button he-button he-button__neutral"
            onClick={noClickHandler}>
            Cancel
          </button>
          <button
            className="govuk-button he-button he-button__primary"
            onClick={yesClickHandler}>
            Yes, discard comments
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmCloseModal;
